import { SideNavProps } from "./SideNavProps"

export const SideNav = (props: SideNavProps) => {
    const navLinks = props.links.map((l) => {
        return (
            <a href={`#${l}`}>
                <p className="capitalize hover:underline border-solid border-2 border-black rounded-md p-2">{l}</p>
            </a>
        )
    })
    return (
        <>
            <nav className="flex flex-col gap-4">
                {navLinks}
            </nav>
        </>
    )
}